import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Dashboard from "@/pages/Dashboard";
import TickerDetail from "@/pages/TickerDetail";
import Header from "@/components/Header";
import MarqueeTape from "@/components/MarqueeTape";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <MarqueeTape />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/ticker/:assetType/:symbol" element={<TickerDetail />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid #27272a",
              borderRadius: "0px",
              fontFamily: "'JetBrains Mono', monospace",
              color: "#ffffff",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
